import { render, staticRenderFns } from "./apartment.vue?vue&type=template&id=b37229d8&scoped=true&"
import script from "./apartment.vue?vue&type=script&lang=js&"
export * from "./apartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37229d8",
  null
  
)

export default component.exports